<template>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Gestión de Calidad</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Pacientes</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Pacientes
          <Badge size="xlarge" severity="success"> {{ totalRecords }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          label="Nuevo"
          v-if="'Paciente Crear' in auth.user.permissions"
          v-tooltip.top="'Nuevo Paciente'"
          icon="pi pi-plus"
          class="p-button-outlined mr-2 p-button-lg"
          @click="openNuevo"
        />
      </div>
    </div>
    <div class="mt-4">
      <DataTable
        ref="dtpacientes"
        :value="pacientes"
        :loading="cargando"
        dataKey="id"
        :paginator="true"
        :rows="20"
        :rowHover="true"
        :filters="buscar"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Pacientes"
        responsiveLayout="scroll"
        filterDisplay="menu"
        :lazy="true"
        :totalRecords="totalRecords"
        v-model:filters="buscar"
        :rowsPerPageOptions="[20, 500, 1000]"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"
        stripedRows
        showGridlines
        selectionMode="single"
        @row-dblclick="editPaciente($event.data)"
      >
        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid"
            >No existen Registros!</span
          ></template
        >
        <Column header="#">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column>

        <Column
          field="id"
          header="CÓDIGO"
          filterMatchMode="startsWith"
          :showFilterMatchModes="false"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="Código"
            />
          </template>
        </Column>
        <Column
          field="nombre"
          header="NOMBRE COMPLETO"
          filterMatchMode="startsWith"
          :showFilterMatchModes="false"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="Nombre Completo..."
            />
          </template>
        </Column>
        <Column
          field="ci_nit"
          header="CI/NIT"
          filterMatchMode="startsWith"
          :showFilterMatchModes="false"
        >
          <template #filter="{ filterModel, filterCallback }">
            <InputText
              type="text"
              v-model="filterModel.value"
              @keydown.enter="filterCallback()"
              class="p-column-filter"
              placeholder="CI/NIT"
            />
          </template>
        </Column>
        <Column field="imagen" header="IMAGEN">
          <template #body="{ data }">
            <template v-if="data.imagen != null">
              <Image
                :src="'data:image/png;base64, ' + data.imagen"
                width="30"
                preview
              ></Image>
            </template>
            <template v-else>
              <p>---</p>
            </template>
          </template>
        </Column>
        <Column field="telefono" header="TELÉFONO">
          {{ data.telefono }}
        </Column>
        <Column field="domicilio" header="DOMICILIO">
          {{ data.domicilio }}
        </Column>
        <Column field="contactos" header="CONTACTOS">
          {{ data.contactos }}
        </Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado.value]">
              {{ data.estado.label }}
            </span>
          </template>
        </Column>
        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              v-tooltip.top="'Ver Acciones'"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog
      v-model:visible="deletePacienteDialog"
      :style="{ width: '450px' }"
      header="Confirmar"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="paciente"
          >Estas Seguro que quieres eliminar al Paciente
          <b>{{ paciente.nombre }}</b> ?</span
        >
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-secondary"
          @click="deletePacienteDialog = false"
        />
        <Button
          label="Si"
          icon="pi pi-check"
          class="p-button-primary"
          @click="deletePaciente"
        />
      </template>
    </Dialog>
    <PacienteCreate
      :show="pacienteDialog"
      :paciente="paciente"
      @closeModal="ocultarDialog"
      @actualizarListado="cargarPacientes"
    >
    </PacienteCreate>
    <PacienteImagenes
      :show="verImagenes"
      :paciente_id="PacienteImagenes"
      @closeModal="ocultarDialogImg"
      @actualizarListado="cargarPacientes"
    ></PacienteImagenes>
  </div>
</template>
  
<script>
import { FilterMatchMode } from "primevue/api";
import PacienteService from "@/service/PacienteService";
import { useAuth } from "@/stores";
import PacienteCreate from "@/module/pacientes/PacienteCreate.vue";
import PacienteImagenes from "@/module/pacientes/PacienteImagenes.vue";

export default {
  components: {
    PacienteCreate,
    PacienteImagenes,
  },
  data() {
    return {
      pacientes: null,
      cargando: true,
      pacienteDialog: false,
      deletePacienteDialog: false,
      paciente: {},
      buscar: {},
      enviado: false,
      estados: [
        { label: "INACTIVO", value: 0 },
        { label: "ACTIVO", value: 1 },
        { label: "OBITADO", value: 2 },
      ],
      errors: {},
      claseEstado: ["status-outofstock", "status-instock", "status-outofstock"],
      lazyParams: {},
      totalRecords: 0,
      verImagenes: false,
      PacienteImagenes: null,
    };
  },
  pacienteService: null,
  auth: null,
  created() {
    this.auth = useAuth();
    this.pacienteService = new PacienteService();
    this.initBuscar();
  },
  mounted() {
    this.lazyParams = {
      first: 0,
      rows: this.$refs.dtpacientes.rows,
      sortField: null,
      sortOrder: null,
      filters: this.buscar,
    };
    this.cargarPacientes();
  },
  methods: {
    onPage(event) {
      this.lazyParams = event;
      this.cargarPacientes();
    },
    onSort(event) {
      this.lazyParams = event;
    },
    onFilter() {
      this.lazyParams.filters = this.buscar;
      this.cargarPacientes();
    },
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "Paciente Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editPaciente(datos);
          },
        },
        /* {
                    label: "Ver Detalle",
                    disabled: "Paciente Ver Detalle" in permisosUsuarioAuth ? false : true,
                    icon: "pi pi-eye",
                    command: () => {
                        this.verDetalle(datos);
                    },
                }, */
        {
          label: "Ver Imagenes",
          icon: "pi pi-image",
          command: () => {
            this.mostrar_imagenes(datos.id);
          },
        },
        {
          label: "Eliminar",
          disabled: "Paciente Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.confirmDeletePaciente(datos);
          },
        },
      ];
    },
    ocultarDialogImg() {
      this.verImagenes = false;
    },
    mostrar_imagenes(paciente_id) {
      this.PacienteImagenes = paciente_id;
      this.verImagenes = true;
    },
    cargarPacientes() {
      this.cargando = true;
      setTimeout(() => {
        this.pacienteService
          .getPacientes({ dt_params: JSON.stringify(this.lazyParams) })
          .then((data) => {
            this.totalRecords = data.pacientes.total;

            this.pacientes = data.pacientes.data || [];
            this.cargando = false;

            this.pacientes.forEach((paciente) => {
              paciente.created_at = new Date(paciente.created_at);
              paciente.updated_at = new Date(paciente.updated_at);
              paciente.estado = {
                label: this.textoEstado(paciente.estado),
                value: paciente.estado,
              };
            });
          });
      }, Math.random() * 1000 + 250);
    },
    openNuevo() {
      this.paciente = {
        estado: { label: "Activo", value: 1 },
      };
      this.enviado = false;
      this.pacienteDialog = true;
    },
    ocultarDialog() {
      this.pacienteDialog = false;
      this.enviado = false;
    },
    ocultalModalCliente() {
      this.pacienteDialog = false;
      this.paciente = {};
    },
    textoEstado(estado) {
      switch (estado) {
        case 0:
          return "INACTIVO";
        case 1:
          return "ACTIVO";
        case 2:
          return "OBITADO";
        default:
          return "SIN ESTADO";
      }
    },
    editPaciente(paciente) {
      this.paciente = {
        ...paciente,
        estado: {
          label: this.textoEstado(paciente.estado.value),
          value: paciente.estado.value,
        },
        sexo: {
          label: paciente.sexo,
          value: paciente.sexo,
        },
      };

      this.pacienteDialog = true;
    },
    confirmDeletePaciente(paciente) {
      this.paciente = { ...paciente };
      this.deletePacienteDialog = true;
    },
    deletePaciente() {
      this.pacienteService.deletePaciente(this.paciente).then((data) => {
        if (data.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Éxito",
            detail: data.mensaje,
            life: 3000,
          });
          this.cargarPacientes();
          this.deletePacienteDialog = false;
          this.paciente = {};
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: data.mensaje,
            life: 3000,
          });
          this.deletePacienteDialog = false;
        }
      });
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.pacientes.length; i++) {
        if (this.pacientes[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    initBuscar() {
      this.buscar = {
        id: { value: null, matchMode: FilterMatchMode.EQUALS },
        nombre: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ci_nit: { value: null, matchMode: FilterMatchMode.EQUALS },
      };
    },
    verDetalle(paciente) {
      this.$router.push(`/paciente/${paciente.id}/detalle`);
    },
    formatDate(value) {
      return value.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
    },
  },
};
</script>
  
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}
</style>  